/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/**
 * A simple decorator that swallows the thrown exception
 * so it doesn't propagate to the console.
 *
 * @param transaction The transaction that might fail.
 */
export const addSwallowException = async (transaction: Promise<void>) => {
    try {
        await transaction;
    } catch {
        // Swallow manually thrown exception for toast.
    }
};
